import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { Button, CardHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ArrowRight } from "lucide-react";

// Cabecera de una tarjeta que muestra una vista previa (los últimos pagos,
// la caja, los vigilantes…) y lleva a la vista completa. El acceso es un
// botón explícito a la derecha, no la cabecera entera.
const SectionCardHeader = ({ icon, color = "primary", title, description, action, className }) => (
  <CardHeader className={`hl-section-header ${className || ""}`.trim()}>
    {icon && (
      <span className={`hl-icon-tile hl-icon-tile--sm hl-icon-tile--${color}`} aria-hidden="true">
        <FontAwesomeIcon icon={icon} fixedWidth />
      </span>
    )}
    <div className="hl-section-header__body">
      <h5 className="hl-section-header__title">{title}</h5>
      {description && <p className="hl-section-header__text">{description}</p>}
    </div>
    {action && (
      <Button
        color="falcon-default"
        size="sm"
        className="hl-section-header__action"
        disabled={action.disabled}
        {...(action.to ? { tag: Link, to: action.to } : { onClick: action.onClick })}
      >
        {action.label}
        <ArrowRight size={14} strokeWidth={2.25} className="ml-1" aria-hidden="true" />
      </Button>
    )}
  </CardHeader>
);

SectionCardHeader.propTypes = {
  icon: PropTypes.object,
  color: PropTypes.string,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  action: PropTypes.shape({
    label: PropTypes.string.isRequired,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
  }),
  className: PropTypes.string,
};

export default SectionCardHeader;
